<!--状态信息-->
<template>
  <div class="status-Container" :style="'height:'+height+'px;'">
    <div class="title">状态信息</div>
    <div class="status-content">
      <p class="status SourceHanSansCN">
        <span>订单状态：</span>
        <span v-if="state == 0">待付款</span>
        <span v-if="state == 2">待评价</span>
        <span v-if="state == 1 || state == 6">服务中</span>
        <span v-if="state == 3">已完成</span>
        <span v-if="state == -2">申请退款</span>
        <span v-if="state == -3">退款成功</span>
        <span v-if="state == -4">退款失败</span>
        <span v-if="state == 7">已取消</span>
        <span v-if="state == 5">交易关闭</span>
      </p>
      <p v-if="state == 0">
        <span>您还有</span>
        <span style="color: red">{{ Minutes }}分{{ Seconds }}秒</span>：来支付订单，超时订单自动取消
      </p>
      <p v-if="state == 1 || state == 2 || state == 6">你的订单商家正在服务中</p>
      <p v-if="state == 3">你的订单已完成</p>
      <p v-if="state == -2">你的订单已提交，等待商家审核</p>
      <p v-if="state == -3">退款金额已原路返回你的账户</p>
      <p v-if="state == -4">商家未同意你的退款申请</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "statusInfo",
  data() {
    return {
      Minutes: "",
      Seconds: ""
    }
  },
  props:['data','state','height'],
  watch: {
    height: function (val, oldVal) {
      console.log(val, oldVal)
    },
    data(val){
      if (this.state == 0) {
        setInterval(() => {
          let num = 3600000 - (new Date().getTime() - this.data.applictionTime);
          num--;
          this.Minutes = new Date(num).getMinutes();
          this.Seconds = new Date(num).getSeconds();
          if (this.Minutes == 0 && this.Seconds == 0) {
            this.cancelOrders(
                this.data.uid,
                this.data.id,
                this.data.orderNum
            );
          }
        }, 1000);
      }
    }
  },
  methods: {
    /*取消订单*/
    cancelOrders(cid, id, order_num) {
      /*cannalByIdOrders({ cid, id, order_num }).then((res) => {
        if (res.data.code == 200) {
          this.$message({message: "取消成功",type: "success",});
          this.$router.back(-1);
        } else {
          this.$message.error("取消失败");
        }
      })*/
    }
  },
  mounted() {
    if (this.state == 0) {
      setInterval(() => {
        let num = 3600000 - (new Date().getTime() - this.data.applictionTime);
        num--;
        this.Minutes = new Date(num).getMinutes();
        this.Seconds = new Date(num).getSeconds();
        if (this.Minutes == 0 && this.Seconds == 0) {
          this.cancelOrders(this.data.uid, this.data.id, this.data.orderNum);
        }
      }, 1000);
    }
  }
}
</script>

<style scoped lang="scss">
.status-Container {
  background: #F9F9F9;
  border: 1px solid #DDDDDD;
  .title {
    background: #F1F1F1;
    border-bottom: 1px solid #DDDDDD;
    padding: 15px 20px;
    font-size: 16px;
    font-weight: 100;
    font-family: 'SourceHanSansCN';
  }
  .status-content {
    padding: 20px;
    .status {
      margin-block-start: 0px;
      margin-block-end: 0px;
      font-size: 18px;
    }
  }
}
</style>